@if (loader.isLoading) {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">{{loader.message}}</div>
  </div>
}
@if (errorMessage) {
  <div class="error-container">
    <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
    <div class="loader-message">{{errorMessage}}</div>
  </div>
}
@if (!errorMessage && !loader.isLoading) {
  <div [class.disable-form]="loader.isLoading" class="form-grid form-container"
    [formGroup]="submissionForm">
    <mat-form-field class="form-group span3">
      <mat-label>TM Name</mat-label>
      <input matInput formControlName="tm_name" placeholder="Enter your full name">
      @if (form['tm_name'].invalid && formSubmitted) {
        <mat-error>
          @if (form['tm_name'].hasError('required')) {
            <span>TM Name is required.</span>
          }
          @else if (form['tm_name'].hasError('maxlength')) {
            <span>TM Name should not exceed {{form['tm_name'].getError('maxlength').requiredLength}} characters.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="form-group span9">
      <mat-label>Submission Title</mat-label>
      <input matInput formControlName="title" placeholder="Enter title">
      @if (form['title'].invalid && formSubmitted) {
        <mat-error>
          @if (form['title'].hasError('required')) {
            <span>Title is required.</span>
          }
          @else if (form['title'].hasError('maxlength')) {
            <span>Title should not exceed {{form['title'].getError('maxlength').requiredLength}} characters.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <div class="contributors-container full-width">
      <span class="label">Contributors (Max {{maxContributorsAllowed}})</span>
      <div class="contributors-flexbox">
        <div class="contributors-chips-gridbox">
          @for (contributor of contributorsList; track contributor) {
            <mqcs-ui-tooltip [text]="contributor.email" [autoAdjust]="true" [position]="'bottom'">
              <mqcs-ui-chips [iconType]="'person'" [icon]="true" [removable]="false" [actionIcon]="true"
                [value]="contributor.displayName" (actionIconClick)="removeContributor(contributor)" [variant]="'solid'">
              </mqcs-ui-chips>
            </mqcs-ui-tooltip>
          }
          @empty {
            <span class="no-contributor-description">
              No Contributors found, Search and add upto {{maxContributorsAllowed}} Contributors
            </span>
          }
        </div>
        <div class="contributors-action-slot">
          @if (showContributorInput) {
            <div class="add-contributor-inline">
              <app-user-autocomplete class="auto-complete" (userSelected)="onContributorSelected($event)"
                [inputDisabled]="contributorsList.length >= maxContributorsAllowed" [showDropdown]="false">
              </app-user-autocomplete>
              <button type="button" class="cancel-add-contributor" title="Cancel adding contributor"
                (click)="closeContributorInput()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
          @else {
            <button type="button" class="add-contributor-button" title="Add Contributor"
              [disabled]="contributorsList.length >= maxContributorsAllowed" (click)="openContributorInput()">
              <mat-icon>add</mat-icon>
              <span>Add Contributor</span>
            </button>
          }
        </div>
      </div>
    </div>
    <mat-form-field class="form-group span3">
      <mat-label>Date</mat-label>
      <input matInput [matDatepicker]="datepicker" [max]="todayDate" formControlName="date">
      <mat-datepicker-toggle matSuffix [for]="datepicker" [disabled]="loader.isLoading"></mat-datepicker-toggle>
      <mat-datepicker #datepicker></mat-datepicker>
      @if (form['date'].invalid && formSubmitted) {
        <mat-error>
          @if (form['date'].hasError('required')) {
            <span>Date is required.</span>
          }
          @if (form['date'].hasError('maxDate')) {
            <span>Future Date cannot be selected.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="form-group span3">
      <mat-label>Company</mat-label>
      <mat-select formControlName="company_id" (selectionChange)="onCompanyChange($event.value)">
        <mat-option value="" disabled>-- Select Company --</mat-option>
        @for (company of companyList; track company.company_id) {
          <mat-option [value]="company.company_id">
            {{ company.company_code }}
          </mat-option>
        }
      </mat-select>
      @if (form['company_id'].invalid && formSubmitted) {
        <mat-error>
          @if (form['company_id'].hasError('required')) {
            <span>Please select a company.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="form-group span3">
      <mat-label>Plant</mat-label>
      <mat-select formControlName="plant_id" (selectionChange)="onPlantChange($event.value)">
        <mat-option value="" disabled>-- Select Plant --</mat-option>
        @for (plant of currentCompany?.plantList; track plant.plant_id) {
          <mat-option [value]="plant.plant_id">
            {{ plant.plant_name }}
          </mat-option>
        }
      </mat-select>
      @if (form['plant_id'].invalid && formSubmitted) {
        <mat-error>
          @if (form['plant_id'].hasError('required')) {
            <span>Please select a plant.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="form-group span3">
      <mat-label>Shop</mat-label>
      <mat-select formControlName="shop_id" (selectionChange)="onShopChange($event.value)">
        <mat-option value="" disabled>-- Select Shop --</mat-option>
        @for (shop of currentPlant?.shopList; track shop.shop_id) {
          <mat-option [value]="shop.shop_id">
            {{ shop.shop_name }}
          </mat-option>
        }
      </mat-select>
      @if (form['shop_id'].invalid && formSubmitted) {
        <mat-error>
          @if (form['shop_id'].hasError('required')) {
            <span>Please select a shop.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <div class="mat-like-field span4">
      <span class="mat-like-label">Description*</span>
      <quill-editor formControlName="issues" [modules]="quillModules" class="mat-like-editor"
        placeholder="Describe what you saw, heard or experienced...">
      </quill-editor>
      @if (form['issues'].invalid && formSubmitted) {
        <mat-error>
          @if (form['issues'].hasError('required')) {
            <span>Description is required.</span>
          }
        </mat-error>
      }
    </div>
    <div class="mat-like-field span4">
      <span class="mat-like-label">Actions/Steps Taken*</span>
      <quill-editor formControlName="actions" [modules]="quillModules" class="mat-like-editor"
        placeholder="What actions were/are to be taken ?">
      </quill-editor>
      @if (form['actions'].invalid && formSubmitted) {
        <mat-error>
          @if (form['actions'].hasError('required')) {
            <span>Actions/Steps Taken is required.</span>
          }
        </mat-error>
      }
    </div>
    <div class="mat-like-field span4">
      <span class="mat-like-label">Improvements/Outcomes*</span>
      <quill-editor formControlName="outcomes" [modules]="quillModules" class="mat-like-editor"
        placeholder="What were the outcomes ? What improved ? What was avoided ?">
      </quill-editor>
      @if (form['outcomes'].invalid && formSubmitted) {
        <mat-error>
          @if (form['outcomes'].hasError('required')) {
            <span>Improvements/Outcomes is required.</span>
          }
        </mat-error>
      }
    </div>
    <mat-form-field class="span2 compact-link-text-field">
      <input matInput formControlName="asset_id" placeholder="Maximo Asset Id">
      @if (form['asset_id'].invalid && formSubmitted) {
        <mat-error>
          @if (form['asset_id'].hasError('required')) {
            <span>Maximo Asset Id is required.</span>
          }
          @else if (form['asset_id'].hasError('maxlength')) {
            <span>Asset Id should not exceed {{form['asset_id'].getError('maxlength').requiredLength}} characters.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="span5 compact-link-text-field">
      <input matInput formControlName="wo_link" placeholder="Maximo Work Order Link">
      @if (form['wo_link'].invalid && formSubmitted) {
        <mat-error>
          @if (form['wo_link'].hasError('required')) {
            <span>Maximo Work Order link is required.</span>
          }
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="span5 compact-link-text-field">
      <input matInput type="url" formControlName="edc_link" placeholder="EDC Reference Link">
      @if (form['edc_link'].invalid && formSubmitted) {
        <mat-error>
          @if (form['edc_link'].hasError('required')) {
            <span>
              @if (form['edc_link'].hasError('required')) {
                <span>EDC link is required.</span>
              }
            </span>
          }
        </mat-error>
      }
    </mat-form-field>
    <div class="div-operational-focus">
      <div class="div-operational-focus-text">Select Operational Focus</div>
      <div class="div-operational-focus-images">
        @for (category of operationalFocusCategories; track category) {
          <mat-card class="operational-focus-card" [class.selected]="category.selected"
            title="{{category.displayName}} : {{category.title}}" [class.disable-form]="category.disabled"
            (click)="onOperationalFocusCategorySelect(category)">
            <div class="operational-focus-emoji" [attr.aria-label]="category.displayName" role="img">
              {{ category.glyph }}
            </div>
            <div class="operational-focus-label">
              {{ category.displayName }}
            </div>
          </mat-card>
        }
      </div>
    </div>
    <div class="operational-focus-fields span9">
      @for (category of operationalFocusCategories; track category) {
        @if (category.selected && category.displayName === 'Productivity') {
          <div class="productivity-container">
            <div class="div-toggle">
              <div class="toggle-label" [class.bold]="!submissionForm.get('productivityType')?.value">
                Health
              </div>
              <mat-slide-toggle color="primary" class="slide-toggle" (change)="onProductivityToggleChange()"
                formControlName="productivityType">
              </mat-slide-toggle>
              <div class="toggle-label" [class.bold]="submissionForm.get('productivityType')?.value">
                Event
              </div>
            </div>
            <ng-container formGroupName="productivityDetails">
              @if (submissionForm.get('productivityDetails.costAvoidance')) {
                <mat-form-field>
                  <mat-label>Cost Avoidance</mat-label>
                  <input matInput formControlName="costAvoidance" placeholder=0 type="number">
                </mat-form-field>
                @if (isVehicleAvoidanceAllowed) {
                  <mat-form-field>
                    <mat-label>Vehicles Saved</mat-label>
                    <input matInput formControlName="numberOfVehicles" placeholder=0 type="number">
                  </mat-form-field>
                }
                <mat-icon matTooltip="Open Downtime Cost Calculator" class="calculate-icon" 
                  (click)="openCalculator()">calculate
                </mat-icon>
              }
              @else if (submissionForm.get('productivityDetails.minutesSaved')) {
                <mat-form-field class="small-form-field">
                  <mat-label>Minutes/Day Saved</mat-label>
                  <input matInput formControlName="minutesSaved" placeholder=0 type="number">
                  @if (productivityControls['minutesSaved'].invalid && formSubmitted) {
                    <mat-error>
                      @if (productivityControls['minutesSaved'].hasError('min')) {
                        <span>Minutes/Day Saved should be > 0</span>
                      }
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Event Description</mat-label>
                  <input matInput formControlName="event" placeholder="Line - Equipment - Event Description">
                  @if (productivityControls['event'].invalid && formSubmitted) {
                    <mat-error>
                      @if (productivityControls['event'].hasError('required')) {
                        <span>Event Description is required.</span>
                      }
                      @else if (productivityControls['event'].hasError('maxlength')) {
                        <span>Event Description should not exceed 
                          {{productivityControls['event'].getError('maxlength').requiredLength}} characters.</span>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              }
            </ng-container>
          </div>
        }
        @else if (category.selected && (category.displayName === 'Quality' || category.displayName === 'Learning')) {
          <mat-form-field class="operational-focus-message-field">
            <mat-label>{{ category.fieldDisplayName }}</mat-label>
            <input matInput [formControlName]="category.fieldName" placeholder="{{ category.fieldDisplayName }}">
            @if (form[category.fieldName].invalid && formSubmitted) {
              <mat-error>
                @if (form[category.fieldName].hasError('required')) {
                  <span>{{ category.fieldDisplayName }} is required.</span>
                }
                @else if (form[category.fieldName].hasError('maxlength')) {
                  <span>{{ category.fieldDisplayName }} should not exceed 
                    {{form[category.fieldName].getError('maxlength').requiredLength}} characters.</span>
                }
              </mat-error>
            }
          </mat-form-field>
        }
        @else if (category.selected) {
          <mat-form-field class="operational-focus-message-field">
            <mat-label>{{ category.fieldDisplayName }}</mat-label>
            <input matInput [formControlName]="category.fieldName" placeholder="{{ category.fieldDisplayName }}">
            @if (form[category.fieldName].invalid && formSubmitted) {
              <mat-error>
                @if (form[category.fieldName].hasError('required')) {
                  <span>{{ category.fieldDisplayName }} is required.</span>
                }
                @else if (form[category.fieldName].hasError('maxlength')) {
                  <span>{{ category.fieldDisplayName }} should not exceed 
                    {{form[category.fieldName].getError('maxlength').requiredLength}} characters.</span>
                }
              </mat-error>
            }
          </mat-form-field>
        }
      }
    </div>
    <div class="div-submit-buttons">
      <button class="action-button secondary" mat-raised-button color="warn" (click)="onBack()" title="Back to Entries">
        Back To List
      </button>
      @if (userAccessLevel) {
        @if (isEditMode) {
          <button class="action-button secondary" mat-raised-button color="primary" (click)="onBack(true)">
            Back To Detail
          </button>
          <button class="action-button" mat-raised-button color="primary" (click)="uploadDocuments()">
            Manage Images
          </button>
        }
        <button class="action-button" mat-raised-button color="primary" (click)="onSubmit()">
          {{ isEditMode ? 'Update' : 'Continue' }}
        </button>
      }
    </div>
  </div>
}